import { z } from 'zod';
import { DecimalString, IsoDateTime, MoneyAmount, UuidString } from '../primitives.js';

/** WriteoffAllocation — привязка расхода материала к Work Order / причине. */
export const WriteoffAllocation = z.object({
  id: UuidString,
  entity_id: UuidString,
  work_order_id: UuidString.nullable(),
  stock_entry_item_id: UuidString,
  item_id: UuidString,
  warehouse_id: UuidString,
  batch_id: UuidString.nullable(),
  qty: DecimalString,
  amount: MoneyAmount,
  reason: z.enum(['bom_consumption', 'scrap', 'rework', 'variance', 'manual_adjustment']),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type WriteoffAllocation = z.infer<typeof WriteoffAllocation>;
